import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Copy, QrCode } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { MenuPDFGenerator } from "@/components/dashboard/MenuPDFGenerator";
import { TableNfcWriteButton } from "@/components/tables/TableNfcWriteButton";

export default function DashboardMenuLink({ menuUrl, menuSlug, restaurant, showQR, setShowQR, copyLink, navigate }) {
  const downloadQR = () => {
    const svg = document.querySelector("#qr-code-container svg");
    if (!svg) return;
    const canvas = document.createElement("canvas");
    canvas.width = 400; canvas.height = 400;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 400, 400);
    const svgData = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 30, 30, 340, 340);
      const a = document.createElement("a");
      a.download = `qrcode-menu-${menuSlug || "restaurante"}.png`;
      a.href = canvas.toDataURL("image/png");
      a.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <Card className="bg-card border-border/50" data-testid="menu-link-section">
      <CardContent className="py-5 space-y-3">
        <p className="text-sm text-muted-foreground">
          Todo listo. Divulga el link del delivery y los pedidos aparecerán en{" "}
          <span className="text-emerald-600 cursor-pointer font-medium" onClick={() => navigate("/orders")}>Pedidos</span>.
        </p>
        <div className="flex items-center gap-3 flex-wrap">
          <a href={menuUrl} target="_blank" rel="noopener noreferrer" className="text-emerald-600 font-mono text-sm hover:underline" data-testid="menu-url">{menuUrl}</a>
          <Button variant="ghost" size="sm" onClick={copyLink} className="h-8 px-2"><Copy className="w-4 h-4" /></Button>
          <Button variant="ghost" size="sm" onClick={() => setShowQR(!showQR)} className="gap-1.5 h-8 text-muted-foreground">
            <QrCode className="w-4 h-4" />QR CODE
          </Button>
          <TableNfcWriteButton url={menuUrl} label="GRABAR NFC" />
        </div>
        {showQR && (
          <div className="flex items-center gap-6 pt-2">
            <div className="bg-white p-4 rounded-lg border" id="qr-code-container">
              <QRCodeSVG value={menuUrl} size={140} />
            </div>
            <div className="text-sm text-muted-foreground">
              <p className="font-semibold text-foreground mb-1">QR Code del menú</p>
              <p className="mb-3">Imprime y coloca en las mesas.</p>
              <div className="flex flex-col gap-2">
                <Button variant="outline" size="sm" className="gap-1.5" data-testid="download-qr-btn" onClick={downloadQR}>
                  Baixar QR
                </Button>
                <MenuPDFGenerator menuUrl={menuUrl} menuSlug={menuSlug} restaurant={restaurant} />
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
